import { Component, OnInit } from '@angular/core';
import DadosCertificadoModel from '../model/dados-certificado.model';
import DadosRegistroModel from '../model/dados-registro.model';
import { MessageService } from '../services/message.service'

@Component({
  selector: 'app-acesso-negado',
  templateUrl: './acesso-negado.component.html',
  styleUrls: ['./acesso-negado.component.css']
})
export class AcessoNegadoComponent implements OnInit {

  public mensagemErro: string;
  public numeroErro: number;
  public mensagemDirecionada: string;

  situacaoNaoCadastrado: number = 0;
  situacaoComRegistrada: number = 2;
  situacaoPreRegistrada: number = 1;
  situacaoSistemaIndisponivel: number = 404;

  constructor(private messageService: MessageService) { }

  ngOnInit() {
    this.mensagemDirecionada = '';
    this.mensagemErro = 'Ocorreu um erro interno';
    this.messageService.currentErrorMessage.subscribe(messageError => {
      if (messageError) {
        this.numeroErro = messageError[0]
        this.mensagemErro = messageError[1]
        this.preencheMensagem();
        this.trataMensagemDeErro();
      }
    });

  }

  get dadosCertificado(): DadosCertificadoModel {
    const dados = sessionStorage['dadosCertificado'];
    // console.log('dadosCertificado: ' + dados);
    return undefined === dados || dados === "undefined" ? undefined : JSON.parse(dados);
  }

  get dadosRegistro(): DadosRegistroModel {
    const dados = sessionStorage['dadosRegistro'];
     //console.log('dadosRegistro: ' + dados);
    return undefined === dados || dados === "undefined" ? undefined : JSON.parse(dados);
  }

  preencheMensagem() {

    if (this.numeroErro === this.situacaoNaoCadastrado)
      this.mensagemDirecionada = this.mensagemSemRegistro();

    if (this.numeroErro === this.situacaoComRegistrada)
      this.mensagemDirecionada = this.mensagemComRegistro();

    if (this.numeroErro === this.situacaoPreRegistrada)
      this.mensagemDirecionada = this.mensagemPreRegistrado();

    if (this.numeroErro === this.situacaoSistemaIndisponivel)
      this.mensagemDirecionada = this.mensagemErro;


  }

  trataMensagemDeErro() {
    if (this.mensagemErro === 'Erro ao tentar gravar Renovacao de Certificado.') {
      this.mensagemDirecionada = 'Não foi possível realizar a renovação do registro.';
    }
  }

  mensagemSemRegistro() {
    return "Identificamos que o certificado digital/token conectividade utilizado não está registrado. Volte à tela principal do CNS ICP V2 e promova o seu registro para continuidade à navegação.";

  }

  mensagemPadrao() {
    return " Dúvidas: contate a Central de Suporte da CAIXA. "
      .concat(" Consulte o número do telefone e horário de atendimento ")
      .concat(" no site da CAIXA na Internet www.caixa.gov.br. ")

  }

  mensagemComRegistro() {
    // return "Identificamos que o Certificado digital utilizado está registrado. Volte à tela principal do CNS ICP V2 e selecione a funcionalidade que desejar.";
    return "O certificado digital/token conectividade utilizado já está registrado!";
  }

  mensagemPreRegistrado() {
    let texto: string = '<b>Pré–registro já efetuado!</b> <br>';
    if(this.dadosRegistro['nu_perfil'] === 12){
      texto = texto + 'Para autorização, encaminhar a Carteira de Identidade Profissional do Magistrado, digitalizada, no endereço <a href="https://www.gerirdemandas.conectividade.caixa.gov.br/" target="_blank"> https://www.gerirdemandas.conectividade.caixa.gov.br</a>, selecionando a opção “Entrada de Dados”, “Nova Demanda”, serviço “Autorização de Perfil Restrito”, produto “Perfil Restrito Magistrado”.';
    }else if (this.dadosRegistro['nu_perfil'] === 22){
      texto = texto + 'Para autorização, encaminhar a Carteira de Identidade e Documento Funcional do Procurador , digitalizados, no endereço <a href="https://www.gerirdemandas.conectividade.caixa.gov.br/" id="meulink" target="_blank"> https://www.gerirdemandas.conectividade.caixa.gov.br</a>, selecionando a opção “Entrada de Dados”, “Nova Demanda”, serviço “Autorização de Perfil Restrito”, produto “Perfil Restrito MPT”.';
    }else{
      texto = texto + 'Para validação apresentar documentação comprobatória em umas das agências da Caixa Econômica Federal.';
    }
    return texto;

  }

  mensagemSistemaIndisponivel(){
    return "Sistema indisponível. Favor tente mais tarde.";
  }

}
